var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-container o-container--xlarge"},[_vm._m(0),_c('section',[_c('div',{staticClass:"o-grid o-grid--no-gutter"},[_vm._m(1),_c('div',{staticClass:"o-grid__cell top-buttons"},[_c('bos-button',{on:{"click":_vm.newFairSeries}},[_vm._v("Neue Messe-Reihe")])],1)]),_c('bos-overview-table',{attrs:{"data":_vm.fairSeries,"columns":[
        {
          key: 'titleDe',
          name: 'Name'
        }
      ],"deleteTitle":"Messe-Reihe löschen","deleteText":obj =>
          'Soll die Messe-Reihe <b>"' +
          obj.titleDe +
          '"</b> wirklich gelöscht werden?',"onEdit":_vm.editFairSeries,"onDelete":_vm.deleteFairSeries,"disableDelete":obj => obj.isUsed}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h3',[_vm._v("Stammdaten bearbeiten")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-grid__cell"},[_c('h4',[_vm._v("Messe-Reihen")])])
}]

export { render, staticRenderFns }